// extracted by mini-css-extract-plugin
module.exports = {"cont":"dd31006766--cont--mcZXH","buttons":"dd31006766--buttons--f0vot"};